import { useMemo } from "react";
import { useDeviceSelectors } from "react-device-detect";
import { useSelector } from "react-redux";
import { logDisplayDevice } from "../../../fetch/insightsHelper";

export default function useReportDevice() {
    const isLoaded = useSelector((state) => state.permissions.isLoaded)

    const [selectors] = useDeviceSelectors()
    const { osName, osVersion, mobileVendor, mobileModel, browserName, browserVersion, deviceType } = selectors;

    const os = `${osName} ${osVersion}`;
    const mobile = !!mobileVendor && mobileVendor != 'none' ? `${mobileVendor} ${mobileModel}` : null;
    const browser = `${browserName} ${browserVersion}`;

    useMemo(() => {

        if (isLoaded) {
            logDisplayDevice(os, mobile, browser, deviceType);
        }
    }, [isLoaded, os, mobile, browser, deviceType]);
}